/**
 * @generated SignedSource<<685e46e95cdcb0516c0f15cb7c43dce0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ErrorType = "ERR_ADSLOT" | "ERR_CARD_BIRTH" | "ERR_CARD_EXPIRED" | "ERR_CARD_NUMBER" | "ERR_CARD_PASSWORD" | "ERR_CARD_PASSWORD_FIVE_TIMES" | "ERR_CREATE_SURVEY_ANSWER" | "ERR_DUPLICATE_APPLY" | "ERR_ETC" | "ERR_EXIST_FINISH_REFUND" | "ERR_EXIST_SEARCH_HISTORY" | "ERR_EXPIRE_URL" | "ERR_HECTO_ETC" | "ERR_HOMETAX_BLOCK_ID" | "ERR_HOMETAX_CALCULATE" | "ERR_HOMETAX_COLLECT" | "ERR_HOMETAX_ETC" | "ERR_HOMETAX_EXPIRE_CERT" | "ERR_HOMETAX_IMPOSSIBLE" | "ERR_HOMETAX_INPUT" | "ERR_HOMETAX_NO_BMAN" | "ERR_HOMETAX_NO_CONTINUE_BMAN" | "ERR_HOMETAX_NO_CORPS_ID" | "ERR_HOMETAX_NO_INCOME_TAX" | "ERR_HOMETAX_NO_JUMIN_ID" | "ERR_HOMETAX_NO_REGIST_CERT" | "ERR_HOMETAX_NO_USER" | "ERR_HOMETAX_OVERLOAD" | "ERR_HOMETAX_PASSWORD" | "ERR_HOMETAX_PASSWORD_CHANGE_REQUEST" | "ERR_HOMETAX_REG_NO" | "ERR_HOMETAX_SERVER_FIX" | "ERR_HOMETAX_SESSION" | "ERR_HOMETAX_SIMPLE_AUTH" | "ERR_HOMETAX_TIMEOUT" | "ERR_LEAVE_REASON" | "ERR_LEAVE_REASON_LOG" | "ERR_NON_PRODUCT_PROMOTION" | "ERR_NOT_EXIST_HISTORY" | "ERR_NOT_EXIST_YEAR_END_TAX_SETTLEMENT" | "ERR_NO_EQUAL_TIN" | "ERR_PROMOTION" | "ERR_SSO" | "ERR_SURVEY" | "ERR_SURVEY_ANSWER" | "ERR_SURVEY_COMPLETED" | "ERR_SURVEY_EXPIRED" | "ERR_UPDATE_SURVEY_ANSWER" | "ERR_USER" | "ERR_USER_ACTION_LOG" | "ERR_USER_PHONE";
export type revokeCancelMutation$variables = {
  refundId: string;
};
export type revokeCancelMutation$data = {
  readonly revokeCancel: {
    readonly errors: {
      readonly code: ErrorType;
      readonly message: string | null | undefined;
    } | null | undefined;
    readonly result: boolean;
  };
};
export type revokeCancelMutation = {
  response: revokeCancelMutation$data;
  variables: revokeCancelMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "refundId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "refundId",
        "variableName": "refundId"
      }
    ],
    "concreteType": "CoreOutput",
    "kind": "LinkedField",
    "name": "revokeCancel",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Errors",
        "kind": "LinkedField",
        "name": "errors",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "revokeCancelMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "revokeCancelMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "654d2479ffc185c08adc1a43a5bcfcf6",
    "id": null,
    "metadata": {},
    "name": "revokeCancelMutation",
    "operationKind": "mutation",
    "text": "mutation revokeCancelMutation(\n  $refundId: String!\n) {\n  revokeCancel(refundId: $refundId) {\n    result\n    errors {\n      code\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c4b207f952df99fa413ed2b2d1753efe";

export default node;
